
const StayConnectedChurch = () => {
  return (
    <div className="bg-[#fff] w-full flex flex-col">
      <div
        className="relative w-full bg-cover bg-center h-[550px] flex items-center justify-center"
        style={{
          backgroundImage: "url('./images/connection.png')",
        }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative text-center px-6 md:px-12 lg:px-20 max-w-4xl">
          <h1 className="text-white text-3xl md:text-5xl font-bold leading-tight mb-4">
            Why Every Christian Should Stay Connected to the Church
          </h1>
          <p className="text-gray-200 text-lg md:text-xl">
            Discover the importance of church community for spiritual growth, accountability, service, and a faith that lasts.
          </p>
        </div>
      </div>

      <section className="body--container w-full px-4 py-10 md:px-12 lg:px-24 xl:px-32">
        <div className="mx-auto max-w-4xl text-gray-800 leading-relaxed">
          <p className="mb-6">
            In today’s fast-paced and increasingly digital world, it can be tempting for Christians to approach faith as a personal,
            private journey. While personal devotion is important, staying connected to the church is vital for spiritual growth,
            accountability, and a life of meaningful service. The church is more than a building or a weekly routine; it is a
            community, a support system, and a place where faith comes alive.
          </p>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              1. A Community of Support and Encouragement
            </h2>
            <p>
              Faith thrives in community. The church provides a network of believers who support each other in prayer, guidance,
              and encouragement. Being part of a church ensures that no one has to walk their faith journey alone.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              2. Spiritual Growth Through Teaching and Worship
            </h2>
            <p>
              Sunday sermons, Bible studies, small groups, and worship services offer opportunities to deepen understanding of
              Scripture and apply it to everyday life. Regular engagement strengthens the relationship with God and renews faith.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              3. Accountability in Faith and Life
            </h2>
            <p>
              Church community provides accountability, helping Christians stay on track spiritually. Fellow believers offer
              correction, encouragement, and guidance, fostering discipline in prayer, moral decision-making, and Scripture engagement.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              4. Opportunities to Serve and Make a Difference
            </h2>
            <p>
              Churches provide countless ways to serve others through charity, outreach, mentoring, and volunteering. Serving allows
              individuals to live out their faith and experience the joy of helping others.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              5. A Place to Worship and Experience God Collectively
            </h2>
            <p>
              Corporate worship offers a unique spiritual experience. Singing, praying, and praising alongside fellow believers
              reinforces faith, builds community bonds, and magnifies the sense of God’s presence.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              6. Passing Faith to the Next Generation
            </h2>
            <p>
              Families connected to the church provide children with exposure to teaching, mentorship, and examples of living
              faith. Sunday School, youth groups, and family programs help transmit faith across generations.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              7. Encouragement During Life’s Challenges
            </h2>
            <p>
              During trials such as illness, loss, or stress, the church offers comfort, prayer, and guidance. Pastors, mentors,
              and fellow believers provide spiritual and practical support, reminding members of God’s constant love.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              Conclusion: Faith Flourishes in Community
            </h2>
            <p>
              Christianity was never intended to be solitary. Staying connected to the church fosters growth, accountability,
              worship, service, and community. Engaging with fellow believers deepens faith, strengthens the church, and equips
              Christians to live out God’s love in daily life.
            </p>
          </div>
        </div>
      </section>

      <section className="mb-12">
        <div className="max-w-4xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-6">
          <div className="flex flex-wrap gap-2">
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Church</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Faith Community</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Spiritual Growth</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Service</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StayConnectedChurch;